"use strict";
exports.__esModule = true;
exports.standardDuration = exports.easeIn = exports.easeInOut = exports.easeOut = exports.sharpCurveTiming = exports.accelerationCurveTiming = exports.standardCurveTiming = exports.decelerationCurveTiming = void 0;
//
// Timing function
//
exports.decelerationCurveTiming = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
exports.standardCurveTiming = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
exports.accelerationCurveTiming = 'cubic-bezier(0.4, 0.0, 1, 1)';
exports.sharpCurveTiming = 'cubic-bezier(0.4, 0.0, 0.6, 1)';
// shortcuts
exports.easeOut = exports.decelerationCurveTiming;
exports.easeInOut = exports.standardCurveTiming;
exports.easeIn = exports.accelerationCurveTiming;
//
// Duration
//
exports.standardDuration = '150ms';
